export default __webpack_public_path__ + "static/media/YS.12761648.webp";